import axios from 'axios'
import { _handleError, _handleSuccess, _getUrl } from './Handler.js'
import store from '../store/index'

export function _getMyNotifications() {

    const config = { headers: { 'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' }, };
    const url = `${_getUrl()}/notifications/search`;
    return axios.get(url, config).then(_handleSuccess, _handleError)
}
export function _delete(id) {
    const config = { headers: { 'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' }, };
    const url = `${_getUrl()}/notifications/${id}`;
    return axios.delete(url, config).then(_handleSuccess, _handleError)
}
export function _setRead(model) {
    const config = { headers: { 'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' }, };
    const url = `${_getUrl()}/notifications/setRead`;
    return axios.put(url, model, config).then(_handleSuccess, _handleError)
}
export function _getTypeUrlStrings(typeId) {
    if (typeId == null)
    {
        return {
            description: "Tanımsız",
            url: "#",
            typeId: null
        };
    }
    if (typeId == 0) {
        return {
            description: "Genel",
            url: "#",
            typeId: 0
        };
    }
    if (typeId == 1) {
        return {
            description: "Masraf",
            url: "expense",
            typeId: 1
        };
    }
    if (typeId == 2) {
        return {
            description: "Avans",
            url: "advance",
            typeId: 2
        };
    }
}